<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-01 17:23:04
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-09 14:27:06
 * @Description: 风险管理信息
 -->
<template>
  <div class="m-risk-information-wrapper">
    <h3 class="title">风险管理信息</h3>
    <h4>一、风险管理架构</h4>
    <p>
      （一）公司根据《网络借贷信息中介机构业务活动管理暂行办法》及国家相关法律法规的要求，根据《公司章程》的要求，
      结合公司自身实际情况，设立严谨规范的风险管理组织架构，制定完善的风险管理制度及内部控制制度，科学划分各组织单位内部责任权限，形成了相互制衡的机制。
    </p>
    <p>
      （二）
      鲸鱼平台做为网络借贷信息中介机构，目前主要撮合三项业务：企业经营性借款、个人经营性借款、个人消费借款。
    </p>
    <p>
      鲸鱼平台要求借款人必须拥有实际经营或消费场景，必须有合理合法的借款用途和还款来源。平台设置了借款人的准入条件，
      对借款人的身份、职业、借款用途、还款来源等进行初审，对不符合准入要求的借款申请予以拒绝，严格控制可能的欺诈和骗贷风险。
    </p>
    <p>
      平台不采取批量化、流水化的业务进件模式，慎用“大数据法则”，无撮合成功率的要求，对每项借款申请均按个案进行风险调查。
      平台对撮合的借款项目进行全面的、全过程的调查、管理，制订并实施借款前的调查流程、内容和调查准则；制订并实施了借款过程中联合评审、综合评判的制度和标准，制订并实施了项目撮合成功后回访制度、风险预警制度、项目逾期管理制度。
    </p>
    <h4>二、风险评估流程</h4>
    <p>
      对于网络借贷信息中介业务项目，平台核查借款人的身份信息、经济、信用状况，以评估其借款用途是否合理、是否具备还款能力。
      平台业务部门和风险控制部门共同对借款人或保证人采取现场走访、电话查询、相关网站查询的方式进行核查，并对项目风险进评估，流程如下：
    </p>
    <p>1、客户通过平台线上提交申请、上门咨询或其他方式等渠道向公司提出借款融资居间服务申请。</p>
    <p>2、客户经理初步审核借款客户资料，符合准入条件的，进入风险核查环节，反之退回申请。</p>
    <p>3、客户经理与风险经理对借款客户进行尽职调查，并出具项目报告书。</p>
    <p>4、项目审批委员会对项目进行联合评审、综合评判，出具审批意见。</p>
    <h4>三、风险预警管理情况</h4>
    <p>
      平台通过项目撮合成功后回访及借款利息还款记录相结合的方式发现借款项目的风险预警信号。
      平台制订并实施项目撮合成功后的跟踪管理制度，建立了借款项目分类评级制度，对回访的频次、内容做出了明确的规定。
    </p>
    <p>
      平台对项目撮合成功后的回访信息进行了总结归纳，明确风险预警信号的内容，并制订了发现风险预警信号的处理办法。
      通过系统的工作，力求及早发现项目风险，及时防范、控制和化解风险。
    </p>
    <h4>四、催收方式</h4>
    <p>
      平台制订并实施了逾期项目管理制度，出现项目逾期时，平台风控人员和客服人员将逾期情况及时告知、反馈项目出借人，并协助配合出借人对借款人进行合法催收。
      若出借人要求申请仲裁机构仲裁或采取其他法律措施，由平台配合采取相关措施。
    </p>
  </div>
</template>
<script>
export default {
  name: 'RiskInformation'
};
</script>
<style lang="less" scoped>
.m-risk-information-wrapper {
  padding: 0 0.3rem;
  .title {
    text-align: center;
    height: 1.2rem;
    line-height: 1.2rem;
    overflow: hidden;
    border-bottom: 1px solid #ececec;
    font-size: 0.3rem;
    font-weight: 600;
  }
  h4 {
    font-size: 0.24rem;
    font-weight: 600;
    color: #444;
    line-height: 2;
  }
  p {
    font-size: 0.24rem;
    text-indent: 2em;
    margin: 0.1rem 0;
  }
}
</style>
